/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import CheckBox from '../../../components/checkbox/CheckBox';
import {dlsColor} from '../../../theme/theme';
import {SubLayerInterface} from './types';

type SubLayerProp = {
  sublayer: SubLayerInterface,
  layerTitle?: string,
  key?: string | number,
  handleCheckboxState?: Function,
  getVisibility?: Function
}

// checkbox label style
const labelStyle = () => ({
  fontFamily    : 'Roboto',
  fontStyle     : 'normal',
  fontWeight    : '600',
  fontSize      : '10px',
  lineHeight    : '16px',
  letterSpacing : '1px',
  textTransform : 'uppercase',
  display       : 'inline-block',
  color         : dlsColor('grey2')
});

const Sublayer = ({
  sublayer,
  handleCheckboxState,
  getVisibility
}: SubLayerProp) => {
  const {id, title, name, level} = sublayer;
  const style   = level ? {marginLeft: `${level * 15}px`} : {};

  //Nested method to get sublayers
  const nestedSublayers = (sublayer.children || []).map((layer, index) => {
    return <Sublayer key={`${layer.title}-${index}`}
      sublayer={layer}
      getVisibility={getVisibility}
      handleCheckboxState={handleCheckboxState}/>;
  });

  function onChange() {
    handleCheckboxState(id, checked);
  }

  const checked = Boolean(getVisibility(id));
  
  return (
    <div key={id} style={style}>
      <CheckBox label={name || title}
        onChange={onChange}
        checked={checked}
        customLabel={labelStyle()}
        labelProps />
      {nestedSublayers}
    </div>
  );
};

export default Sublayer;
